export const CONSTANTS = {
	ADVERTISERS: 'advertisers',
	CAMPAIGNS: 'campaigns',
	LOAD_TIME: 3000 // milli seconds
};

export const PRODUCT_NAMES = {
	DISPLAY: 'Display',
	GEOFENCE: 'GeoFence',
	GEOVIDEO: 'GeoVideo',
	PREROLL: 'Pre Roll'
};

export const PATHS = {
	CTV: 'ctv',
	DISPLAY: 'display',
	GEOFENCE: 'geofence',
	GEOVIDEO: 'geovideo',
	LOGIN: 'login',
	OTT: 'ott',
	OVERVIEW: 'overview',
	PREROLL: 'preroll',
	RADIO: 'radio',
	AUDIO: 'audio',
	SEM: 'sem',
	SOCIAL: 'social',
	TELEVISION: 'cox_tv',
	TELEVISION_MIDCO: 'midco_tv',
	SIMPLIFI_CTV: 'simplifi_ctv',
	TVE: 'tve',
	Email: 'email',
	TRITON_AUDIO: 'triton_radio',
	RESPONSIVE_DISPLAY: 'responsive_display',
	GAM: 'gam',
	DOOH: 'dooh'
};

export const MAP_CONSTANTS = {
	STATE: {
		ALL: 'all',
		CTV: 'ctv',
		DISPLAY: 'display',
		GEOFENCE: 'geofence',
		GEOVIDEO: 'geovideo',
		PREROLL: 'preroll',
		RADIO: 'radio',
		AUDIO: 'audio',
		SEM: 'sem',
		SOCIAL: 'social',
		TELEVISION: 'cox_tv',
		TELEVISION_MIDCO: 'midco_tv',
		SIMPLIFI_CTV: 'simplifi_ctv',
		YOUTUBE: 'youtube',
		TRITON_AUDIO: 'triton_radio',
		RESPONSIVE_DISPLAY: 'responsive_display',
		GAM: 'gam',
		EMAIL: 'email',
		DOOH: 'dooh'
	}
};

export const OPTIONS = {
	ADVERTISERS: {
		DEFAULT_SELECTION: 10
	},
	CAMPAIGNS: {
		DEFAULT_CAMPAIGNS: 12,
		MAXIMUN_CAMPAIGNS: 25
	}
};

export const DATEPICKER = {
	FORMAT: 'MM-DD-YYYY'
};

export const EVENT_EMITTERS = {
	ADVERTISERS: 'advertisers',
	CAMPAIGNS: 'campaigns',
	CAMPAIGN_LOADED: 'campaign-loaded',
	CAMPAIGN_REQUEST_COUNTER: 'campaign-request-counter',
	CHANGE_PASSWORD: 'change-password',
	DATE_RANGE: 'date-range',
	INITIATE_MAP_STATS: 'initiate-map-stats',
	LOGOUT: 'logout',
	NAVIGATE: 'navigate',
	NAVIGATE_TO_SLIDE: 'navigate_to_slide',
	NAVIGATE_TO_SLIDE_WIDGET: 'navigate-to-slide-widget',
	NAVIGATION_DONE: 'navigation-done',
	NAVIGATION_STATUS: 'navigation-status',
	PRINTABLE_PERMISSIONS: 'printable-permissions',
	REFRESH_CAMPAIGNS: 'selected-campaigns',
	REFRESH_DATA: 'refresh-data',
	REFRESH_DATA_SOURCE: 'refresh-data-source',
	RELOAD: 'reload',
	SELECTED_CAMPAIGN_LOADED: 'selected-campaign-loaded',
	SET_ACTIVE_STATE_TO_CURRENT_SLIDE: 'set-active-state-to-current-slide',
	TOGGLE_LAYOUT: 'toggle-layout',
	TOGGLE_PRODUCT_MAP_LEGEND: 'toggle-product-map-legend',
	UPDATE_PRODUCT_MAP_LEGEND: 'update-product-map-legend',
	VALIDATION: 'validation',
	TOGGLE_LEFTPANE: 'toggleleft',
	HOVER_START_DATE: 'hoverstartdate',
	HOVER_END_DATE: 'hoverenddate',
	PRODUCT_DOWNLOAD_STATUS_CHECK: 'product-download-status-check',
	PICK_START_DATE: 'pickStartDate',
	PICK_END_DATE: 'pickEndDate',
	CAROUSEL_CHART_REDRAW: 'redrawChart',
	UPDATE_OVERVIEW_REPORT_DETAILS: 'updateOverviewReportDetails',
	HAS_PRODUCT_PRINTABLE_ACCESS: 'hasProductPrintableAccess'
};

export const COLORS = {
	PRIMARY: 'primary',
	QUATERNARY: 'quaternary',
	QUINARY: 'quinary',
	SECONDARY: 'secondary',
	TERTIARY: 'tertiary'
};

export const PREFIXES = {
	MAX_PREFIX: 'max_'
};

export const SEM_AVG_POSITION = {
	AVG_POSITION_KEYS: ['avg_position', 'avgPosition', 'Avg. Position'],
	IMPRESSIONS_KEYS: ['abs_top_impression_share', 'top_impression_share']
};

export const FILE_MEDIA_TYPES = {
	MP4: 'video/mp4'
};

export const SEM_CALLS_SOURCE = {
	CLICKS: 'clicks',
	CTR: 'ctr'
};

export const UNSORTED_TABLE_KEY_NAMES = [
	'MARKETRON_DAILY_ENGAGEMENTS_DISPLAY',
	'MARKETRON_DAILY_ENGAGEMENTS_GEOFENCE',
	'MARKETRON_DAILY_ENGAGEMENTS_PREROLL',
	'MARKETRON_DAILY_ENGAGEMENTS_GEOVIDEO',
	'MARKETRON_PLACEMENTS_GEOVIDEO',
	'PLATFORM_AND_FEATURED_NETWORK_PERFORMANCE_CTV',
	'PLACEMENTS_WITH_RETARGET_DISPLAY',
	'MARKETRON_PLACEMENTS_DISPLAY',
	'DAILY_ENGAGEMENTS_WITH_EMPTY_DATE_RADIO',
	'PLACEMENTS_RADIO'
];

export const PRINTABLE_ACCESS_KEYS = {
	CTV: 'has_ctv_access',
	DISPLAY: 'has_display_access',
	GEOFENCE: 'has_geofence_access',
	GEOVIDEO: 'has_geovideo_access',
	OVERVIEW: 'has_overview_access',
	PREROLL: 'has_preroll_access',
	SEM: 'has_sem_access',
	SOCIAL: 'has_social_access',
	TELEVISION: 'has_television_access',
	RADIO: 'has_radio_access',
	AUDIO: 'has_radio_access',
	OTT: 'has_ctv_access',
	TVE: 'has_simplifi_ctv_access',
	EMAIL: 'has_email_access',
	TRITON_RADIO: 'has_triton_radio_access',
	RESPONSIVE_DISPLAY: 'has_responsive_display_access',
	GAM: 'has_gam_access',
	DOOH: 'has_dooh_access',
	DOOHVideo: 'has_dooh_video_access'
};

export const PRINTABLE_OVERVIEW_ACCESS_KEYS = {
	OVERVIEW: [
		'has_ctv_access',
		'has_display_access',
		'has_geofence_access',
		'has_geovideo_access',
		'has_overview_access',
		'has_preroll_access',
		'has_sem_access',
		'has_social_access',
		'has_television_access',
		'has_radio_access',
		'has_ctv_access',
		'has_simplifi_ctv_access',
		'has_email_access',
		'has_triton_radio_access',
		'has_responsive_display_access',
		'has_gam_access',
		'has_dooh_access',
		'has_dooh_video_access'
	]
};

export enum PRISTINE_PERMISSIONS {
	hasDisplay = 'has_display_access',
	hasPreroll = 'has_preroll_access',
	hasSem = 'has_sem_access',
	hasGeoFence = 'has_geofence_access',
	hasGeoVideo = 'has_geovideo_access',
	hasCtv = 'has_ctv_access',
	hasSocial = 'has_social_access',
	hasTelevision = 'has_television_access',
	hasRadio = 'has_radio_access',
	hasSimplifiCtv = 'has_simplifi_ctv_access',
	hasEmail = 'has_email_access',
	hasGAM = 'has_gam_access',
	hasStandaloneGAM = 'has_standalone_gam',
	hasDOOH = 'has_dooh_access',
	hasDOOHVideo = 'has_dooh_video_access'
}

export const R7_CHARTS_TOOLTIPS = {
	backgroundColor: '#fff',
	borderColor: '#fff',
	borderRadius: 8,
	padding: 10,
	shadow: {
		color: '#78787880',
		offsetX: 0,
		offsetY: 1.5,
		opacity: 0.5,
		width: 3
	},
	useHTML: true
};

export const R11_CHARTS_TOOLTIPS = {
	backgroundColor: '#fff',
	borderColor: '#fff',
	borderRadius: 0,
	padding: 0,
	shadow: {
		color: '#78787880',
		offsetX: 0,
		offsetY: 1.5,
		opacity: 0.5,
		width: 3
	},
	useHTML: true
};
export const R9_CHARTS_TOOLTIPS = {
	backgroundColor: '#fff',
	borderColor: '#fff',
	borderRadius: 15,
	padding: 0,
	shadow: {
		color: '#78787880',
		offsetX: 0,
		offsetY: 0,
		opacity: 0.2,
		width: 2
	},
	useHTML: true
};
export const R1102_CHARTS_TOOLTIPS = {
	backgroundColor: '#fff',
	borderColor: '#e7e7e7',
	borderRadius: 5,
	padding: 0,
	shadow: false,
	useHTML: true
};

export const HIGHCHARTS_LEGEND_ALIGN = {
	center: 'center',
	left: 'left',
	right: 'right'
};

export const HIGHCHARTS_LEGEND_VERTICAL_ALIGN = {
	bottom: 'bottom',
	middle: 'middle',
	top: 'top'
};

export const HIGHCHARTS_LEGEND_LAYOUT = {
	horizontal: 'horizontal',
	proximate: 'proximate',
	vertical: 'vertical'
};

export const PRINTABLE_TOOLTIP = {
	DISABLED: 'Reports are available for up to 10 Advertisers or 12 Campaigns <br/> and date ranges up to 1 year.',
	ENABLED: 'Generate Report',
	ENABLED_OVERVIEW_TOOLTIP: 'Generates a PDF report of performance across all products.',
	R9_ENABLED: 'Preview Report'
};
export const CSV_TOOLTIP = {
	TOOLTIP: 'Generates 1 Excel file per product summarizing campaign performance. <br/> Pop-up blockers must be disabled'
};

export const ANALYTICS_CONFIGS = {
	R11_DEFAULT: 'default-r11',
	R1_DEFAULT: 'default-r1',
	R2_DEFAULT: 'default-r2',
	R3_DEFAULT: 'default-r3',
	R3_MARKETRON_DEFAULT: 'default-marketron-r3',
	R4_DEFAULT: 'default-r4',
	R5_DEFAULT: 'default-r5',
	R7_DEFAULT: 'default-r7',
	R10_DEFAULT: 'default-r10',
	R13_DEFAULT: 'default-r13'
};

export const COUNTRY_MAP_COORDINATES = {
	USA: {
		lng: -68.5,
		lat: 35
	},
	CAN: {
		lng: -76.5,
		lat: 60
	}
};

export const GAM_PRODUCT_SEPERATED_Rs = [
	'default-r101',
	'default-r6',
	'default-r8',
	'default-r104',
	'default-r13',
	'lee-r13'
];
